import React, { useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ExportToCsv } from 'export-to-csv';

export default function TaskTable({ columns, data, loading }) {
    //const [load, setLoad] = useState(loading);
    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers: columns.map((c) => c.header),
    };

    const csvExporter = new ExportToCsv(csvOptions);

    const handleExportData = () => {
        csvExporter.generateCsv(data);
    };

    return (
        <MaterialReactTable
            className="p-4 w-auto mt-auto text-left bg-white rounded-lg border shadow-md sm:p-8 dark:bg-gray-800 dark:border-gray-700"
            columns={columns}
            data={data}
            enableStickyHeader
            state={{
                isLoading: loading,
            }}
            enableDensityToggle={false}
            initialState={{
                columnVisibility: {
                    core_blacklisteduser: false,
                    deleted_user: false,
                    core_bannedemployer: false,
                },
                density: 'compact',
            }}
            positionToolbarAlertBanner="bottom"
            renderTopToolbarCustomActions={({ table }) => (
                <Box
                    sx={{
                        display: 'flex',
                        gap: '1rem',
                        p: '0.5rem',
                        flexWrap: 'wrap',
                    }}
                >
                    <Button
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                    >
                        Export All Data
                    </Button>
                </Box>
            )}
        />
    );
}
